<template>
  <div>
    <b-container class="mb-5">
      <h1 class="mt-5">Du möchstest dein Abo kündigen?</h1>
      <b-row>
        <b-col cols="12" class="mb-3">
          <p>Wenn du dein Auto Abo kündigen möchtest, gebe bitte folgende Daten an:</p>
        </b-col>

        <b-col cols="12" class="mb-3">
          <b-alert variant="success" :show="requestSucceeded">
            <p class="font-weight-bold">Dein Kündigungsantrag ist bei uns eingegangen!</p>
            Wenn die von dir angegebene Kombination aus E-Mail-Adresse und Abonnement-ID korrekt ist, erhältst in Kürze eine E-Mail in der du deine Kündigung bestätigen kannst
          </b-alert>
        </b-col>

        <b-col cols="6" class="mb-3">
          <b-form-group
              label="E-Mail Adresse"
              label-for="mail"
              class="mb-0"
          >
            <b-form-input
                id="mail"
                v-model="fields.mail.value"
                :state="fields.mail.state"
                placeholder="E-Mail"
                aria-describedby="mail-error"
            ></b-form-input>
            <b-form-invalid-feedback id="mail-error">
              {{ fields.mail.error }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" class="mb-3">
          <b-form-group
              label="Passwort"
              label-for="password"
              class="mb-0"
          >
            <b-form-input
                id="password"
                v-model="fields.password.value"
                :state="fields.password.state"
                type="password"
                aria-describedby="password-error"
            ></b-form-input>
            <b-form-invalid-feedback id="password-error">
              {{ fields.password.error }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" class="mb-3">
          <b-form-group
              label="Abo ID"
              label-for="subscriptionId"
              class="mb-0"
          >
            <b-form-input
                id="subscriptionId"
                v-model="fields.subscriptionId.value"
                :state="fields.subscriptionId.state"
                placeholder="Abo Nummer"
            ></b-form-input>
            <b-form-invalid-feedback id="subscriptionId-error">
              {{ fields.subscriptionId.error }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mb-3">
          <small>Eine Kündigung ist auch jederzeit über dein persönliches Dashboard möglich. Bitte beachte, dass die Kündigung nicht zurückgenommen werden kann und erst ab dem nächstmöglichen Zeitpunkt in Kraft treten wird. Wenn die von dir angegebene Kombination aus E-Mail-Adresse und Abonnement-ID korrekt ist, erhältst in Kürze eine E-Mail in der du deine Kündigung bestätigen kannst. Achte deshalb besonders auf die Korrektheit deiner angegebenen Daten.</small>
        </b-col>
        <b-col cols="12">
          <b-button variant="danger" @click="submit" v-if="!isSubmitting">Kündigung beantragen</b-button>
          <b-button variant="danger" @click="submit" v-if="isSubmitting" disabled>Kündigung beantragen</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
    import { BContainer, BRow, BCol, BButton, BFormInput, BFormGroup, BFormInvalidFeedback, BAlert } from "bootstrap-vue";
    export default {
      name: "SubscriptionCancellationForm",
      components: {
        BContainer, BRow, BCol, BButton,
        BFormInput, BFormGroup, BFormInvalidFeedback, BAlert
      },
      data() {
        return {
          error: false,
          errorSum: 0,
          requestSucceeded: false,
          isSubmitting: false,
          fields: {
            mail: {
              value: '',
              state: null,
              error: 'Pflichtfeld'
            },
            password: {
              value: '',
              state: null,
              error: 'Pflichtfeld'
            },
            subscriptionId: {
              value: '',
              state: null,
              error: 'Pflichtfeld'
            },
          },
        }
      },
      methods: {
        submit() {
          this.validateForm()
          this.error = false

          if(this.errorSum === 0){
            this.isSubmitting = true
            axios.put('api/subscription/cancel', {
              email : this.fields.mail.value,
              password : this.fields.password.value,
              order_number : this.fields.subscriptionId.value,
            }).then(response => {
              this.isSubmitting = false
              if(response.data){
                this.requestSucceeded = true
                this.fields.mail.value = ''
                this.fields.password.value = ''
                this.fields.subscriptionId.value = ''
              } else {
                this.error = true
              }
            }).catch(error => {
              this.isSubmitting = false
              this.error = true
            });
          }
        },
        validateForm() {
          this.errorSum = 0
          this.validateEmail()
          this.validatePassword()
          this.validateSubscriptionId()
        },
        validateEmail(){
          this.fields.mail.state = this.fields.mail.value !== ''
          if(!this.fields.mail.state){
            this.errorSum++
          }
        },
        validatePassword(){
          this.fields.password.state = this.fields.password.value !== ''
          if(!this.fields.password.state){
            this.errorSum++
          }
        },
        validateSubscriptionId(){
          this.fields.subscriptionId.state = this.fields.subscriptionId.value !== ''
          if(!this.fields.subscriptionId.state){
            this.errorSum++
          }
        },
      }
    }
</script>

<style scoped>

</style>
